import { render, staticRenderFns } from "./ListReceivingItems.vue?vue&type=template&id=6a2843b7&"
import script from "./ListReceivingItems.vue?vue&type=script&lang=ts&"
export * from "./ListReceivingItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2843b7')) {
      api.createRecord('6a2843b7', component.options)
    } else {
      api.reload('6a2843b7', component.options)
    }
    module.hot.accept("./ListReceivingItems.vue?vue&type=template&id=6a2843b7&", function () {
      api.rerender('6a2843b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/goods-receipt-price/ListReceivingItems.vue"
export default component.exports